import { AITraits, TraitPriorties } from "../aiHelpers";
import { createAction } from "../../../actions/Action";
import { wait } from "../../../actions/ActionMovement";
import { Actor } from "../../Actor";
import { gameData } from "../../../GameManager";
import {
  checkCorners,
  fitAndValidateWord,
  piecePos,
  WordResult,
} from "../../../words/wordUtils";
import EntityManager from "../../../EntityManager";
import { playWord } from "../../../actions/ActionWord";
import { RNG } from "rot-js";

const ASSUMED_DIRECTION = { x: 1, y: 0 };
export default {
  randomMove: {
    max: TraitPriorties.BASE_MOVE,
    getPriority: (actor: Actor) => {
      return [TraitPriorties.BASE_MOVE, null];
    },
    getAction: (actor: Actor) => {
      const results: WordResult[] = [];
      actor.aiProps.words?.forEach((word) => {
        actor.pieces.forEach((piece) => {
          let fits;
          fits = fitAndValidateWord({ x: 0, y: 1 }, piece, word, actor.id);
          results.push(...fits);

          fits = fitAndValidateWord({ x: 1, y: 0 }, piece, word, actor.id);
          results.push(...fits);

          fits = checkCorners(
            actor.pieceDirection || ASSUMED_DIRECTION,
            piece,
            word
          );
          results.push(...fits);
        });
      });

      const [_, best] = results.reduce(
        (best, r) => {
          if (
            r.valid &&
            r.pieces &&
            !r.failedCross &&
            (r.seenOwner || r.crosses?.find((cross) => cross.seenOwner))
          ) {
            if (actor.aiProps.timid) {
              const overPlayer =
                r.ownersCovered?.find((o) => o === gameData.player.id) ||
                r.crosses?.find((c) =>
                  c.ownersCovered?.find((o) => o === gameData.player.id)
                );
              if (overPlayer) {
                return best;
              }
            }
            const nonPlayerOwner =
              r.ownersCovered?.find(
                (o) => o !== gameData.player.id && o !== actor.id
              ) ||
              r.crosses?.find((c) =>
                c.ownersCovered?.find(
                  (o) => o !== gameData.player.id && o !== actor.id
                )
              );
            if (!nonPlayerOwner) {
              let foundConnector = false;
              for (const checker of r.pieces) {
                const existing = gameData.pieces.get(piecePos(checker));
                if (existing && existing.owner === actor.id) {
                  foundConnector = true;
                }
              }

              if (!foundConnector) {
                return best;
              }

              r.pieces.forEach((p) => {
                const distance = gameData.dMapPlayer?.get(p);
                if (distance != null) {
                  if (distance < best[0]) {
                    best[0] = distance;
                    best[1] = [r];
                  } else if (distance === best[0]) {
                    best[1].push(r);
                  }
                }
              });
            }
          }
          return best;
        },
        [Number.MAX_SAFE_INTEGER, []] as [number, WordResult[]]
      );
      actor.aiProps.timid = false;
      if (best) {
        const toUse = RNG.getItem(best);
        if (toUse) {
          toUse.pieces?.forEach((p) => {
            p.owner = actor.id;
            p.id = EntityManager.getId();
          });
          return createAction(playWord, actor, {
            info: toUse,
            freeAction: false,
            noTriggers: false,
          });
        }
      }
      return createAction(wait, actor, { target: { x: 0, y: 0 } });
    },
  },
} as Record<string, AITraits<any>>;
